<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <polyline
            class="a"
            :class="{ b: direction === 1 }"
            points="22.251 8.573 12.001 2.747 1.751 8.573"
        />

        <polyline
            class="a"
            :class="{ b: direction === -1 }"
            points="1.751 15.509 12.001 21.335 22.251 15.509"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'SortArrowIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
        direction: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}

.b {
    stroke-width: 3px;
}
</style>
